import React, { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import { withFormsy } from "formsy-react";

import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.us";

class PhoneNumberInput extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange = event => {
    let input = event.target.value;
    this.props.setValue(input.replace(/\s/g, ""));
  };

  render() {
    let { name, placeholder, label, required, disabled } = this.props;

    name = name.replace(/_/g, " ");
    let fieldLabel = required ? (label += " *") : label;

    return (
      <div className="form-group row">
        <label
          className="control-label"
          htmlFor={name}
          style={{ textTransform: "uppercase" }}
        >
          {fieldLabel}
        </label>
        <Cleave
          formNoValidate
          className="form-control"
          options={{ phone: true, phoneRegionCode: "US" }}
          name={name}
          label={label}
          placeholder={placeholder}
          value={this.props.getValue()}
          disabled={disabled}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

PhoneNumberInput.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  getValue: PropTypes.func,
  setValue: PropTypes.func,
  required: PropTypes.bool
};

export default withFormsy(PhoneNumberInput);
